// SSN & DOB are display-only, not inline-editable (MVP-30783).
export const EDITABLE_PATIENT_COLUMNS = Object.freeze({
  patientStatus: "dropdown",
  assignee: "searchable",
  facility: "dropdown",
  physician: "searchable",
  phone_number: "text",
  followupDate: "date",
  isDeceased: "switch"
});

export const isEditablePatientColumn = (columnKey) =>
  Object.prototype.hasOwnProperty.call(EDITABLE_PATIENT_COLUMNS, columnKey);

export const EDITABLE_ENROLLMENT_COLUMNS = Object.freeze({
  applicationStatus: "dropdown",
  validThrough: "date",
  approvedAmount: "text",
  appliedDate: "date",
  approvedDate: "date",
  member_id: "text",
  enrollmentAssignee: "searchable"
});

export const isEditableEnrollmentColumn = (columnKey) =>
  Object.prototype.hasOwnProperty.call(EDITABLE_ENROLLMENT_COLUMNS, columnKey);

export const EDITABLE_CLAIM_COLUMNS = Object.freeze({
  claimDate: "date",
  claimStatus: "dropdown",
  claimFollowupDate: "date",
  claimSubmittedDate: "date",
  claimFacility: "searchable",
  dateReceived: "date",
  approvedDate: "date",
  checkNumber_ACH: "text",
  claimAssignee: "searchable",
  enrollmentAssignee: "searchable"
});

export const isEditableClaimColumn = (columnKey) =>
  Object.prototype.hasOwnProperty.call(EDITABLE_CLAIM_COLUMNS, columnKey);
